/* ==========================================================================
   Incipit · Bloc texte centré — reveal animations
   • IntersectionObserver pour déclencher fade + translate
   • One-shot, respecte prefers-reduced-motion
   • Délai par élément via data-reveal-delay (en ms)
   ========================================================================== */

(function () {
  'use strict';

  function initReveal(section) {
    const elements = section.querySelectorAll('[data-reveal]');
    if (elements.length === 0) return;

    // Fallback : pas d'IntersectionObserver → tout révéler immédiatement
    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    // Reduced motion : afficher direct, pas d'animation
    const prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      elements.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = parseInt(el.dataset.revealDelay, 10) || 0;
        setTimeout(() => el.classList.add('is-revealed'), delay);
        observer.unobserve(el);
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -10% 0px',
    });

    elements.forEach((el) => observer.observe(el));
  }

  function initSection(section) {
    if (!section || section.dataset.incipitTbInit === 'true') return;
    section.dataset.incipitTbInit = 'true';
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll('.incipit-tb').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section reloads in Shopify theme editor
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.incipit-tb');
    if (section) initSection(section);
  });
})();